/**
 * Image Loader Component
 * Manages image loading state with event listener attachment
 */

import type { Magics } from 'alpinejs';

interface ImageLoaderData {
    isLoaded: boolean;
    init(this: ImageLoaderContext): void;
}

type ImageLoaderContext = ImageLoaderData & Magics<ImageLoaderData>;

export default function imageLoader() {
    return {
        // Component state
        isLoaded: false,

        // Initialize component
        init() {
            const img = this.$el.querySelector('img') as HTMLImageElement | null;
            if (img) {
                img.addEventListener('load', () => {
                    this.isLoaded = true;
                });
                // Handle cached/already-loaded images
                if (img.complete && img.naturalWidth > 0) {
                    this.isLoaded = true;
                }
            }
        },
    } as ImageLoaderData;
}
